/**
 * NCES EDGE Locale Codes — ZCTA-level lookup.
 * Generated by data_raw/build_locale.R from the NCES 2021 ZCTA locale file.
 *
 * Value: 2-digit locale code (12-category scheme):
 *   11/12/13 City-Large/Midsize/Small      21/22/23 Suburb-Large/Midsize/Small
 *   31/32/33 Town-Fringe/Distant/Remote    41/42/43 Rural-Fringe/Distant/Remote
 *
 * Geography: 2020 Census ZCTAs (joins on the app's `postcode` key, like RUCA/FAR).
 * License: US federal government work — public domain.
 *
 * Source: https://nces.ed.gov/programs/edge/Geographic/ZCTAAssignments
 */

let _data = null;
let _loadPromise = null;

export function loadLocaleData() {
  if (_data) return Promise.resolve();
  if (_loadPromise) return _loadPromise;
  _loadPromise = fetch(`${process.env.PUBLIC_URL}/data/locale.json`)
    .then(r => {
      if (!r.ok) throw new Error(`Failed to load NCES locale data (${r.status})`);
      return r.json();
    })
    .then(d => { _data = d; _loadPromise = null; })
    .catch(err => { _loadPromise = null; throw err; });
  return _loadPromise;
}

export function getLocaleForZcta(zip) {
  if (!_data || zip == null) return null;
  const key = String(zip).padStart(5, "0");
  const v = _data[key];
  return typeof v === "number" ? v : null;
}

const LOCALE_LABELS = {
  11: "City – Large", 12: "City – Midsize", 13: "City – Small",
  21: "Suburb – Large", 22: "Suburb – Midsize", 23: "Suburb – Small",
  31: "Town – Fringe", 32: "Town – Distant", 33: "Town – Remote",
  41: "Rural – Fringe", 42: "Rural – Distant", 43: "Rural – Remote",
};

export function getLocaleDescription(code) {
  if (code == null) return null;
  return LOCALE_LABELS[code] ?? null;
}

const locale = { loadLocaleData, getLocaleForZcta, getLocaleDescription };
export default locale;
